import Vue from "vue";
import $api from '../api'
console.log('$api',$api);
import store from '../store'
import VueCookies from "vue-cookies";
import Router from "vue-router";
// import HelloWorld from '@/components/HelloWorld'
import Header from "../components/header/Header.vue";
import personalCentre from "../page/personal-Centre.vue";
import editor from "../page/editor/editor.vue";
// 登陆注册
import Login from "@/components/login";
// 首页
import index from "../page2/index/index";
// 搜索
import search from "../page2/search/search";
import search_course from "../page2/search/search_course";
import search_pubilc from "../page2/search/search_pubilc";
import search_selfStudy from "../page2/search/search_selfStudy";
import search_TestPaper from "../page2/search/search_TestPaper";
import search_Section from "../page2/search/search_Section";
import search_languageTest from "../page2/search/search_languageTest";
// 热门公开课
import publicClass_list from "../page2/publicClass/publicClass_list";
import publicClass_details from "../page2/publicClass/publicClass_details";
import publicClass_order from "../page2/publicClass/publicClass_order";
import publicClass_pay from "../page2/publicClass/publicClass_pay";
import publicClass_success from "../page2/publicClass/publicClass_success";
// 自学备考专区
import selfStudy_list from "../page2/selfStudy/selfStudy_list";
import selfStudy_details from "../page2/selfStudy/selfStudy_details";
// 语言测试
import languageTest from "../page2/languageTest/languageTest";
// 课程列表
import course from "../page2/courseList/course";
import course_list from "../page2/courseList/course_list";
import course_details from "../page2/courseList/course_details";
import course_order from "../page2/courseList/course_order";
import course_auxiliary from "../page2/courseList/course_auxiliary";
import course_pay from "../page2/courseList/course_pay";
import course_success from "../page2/courseList/course_success";
import course_search from "../page2/courseList/course_search";
// 老师列表
import teacher_list from "../page2/teacherList/teacher_list";
import teacher_details from "../page2/teacherList/teacher_details";
// 积分商城
import shop_list from "../page2/shopping/shop_list";
import shop_details from "../page2/shopping/shop_details";
import shop_order from "../page2/shopping/shop_order";
// 协议
import agreement1_yhzx from "../page2/agreement/agreement1_yhzx";
import agreement1_ysbh from "../page2/agreement/agreement1_ysbh";
// 客户端下载
import downloads from "../page2/client/downloads";
//练习系统
import practice_system_list from "../page2/practiceSystem/list";
import practice_system_list2 from "../page2/practiceSystem/list2";
//loading
import loadingPage from "../page/loading/pageLoading";

Vue.use(Router);
// 解决重复点击路由报错的BUG
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  // 跳转页面页面位置问题
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  mode: "history",
  linkActiveClass: "is-active",
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      meta: {
        title: "启德考培在线",
        keyWords: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/index",
      name: "index_2",
      component: index,
      meta: {
        title: "启德考培在线",
        keyWords: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/search",
      name: "search",
      component: search,
      // redirect: "/publicClass_lise",
      meta: {
        title: "启德考培在线",
        keyWords: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/search_course",
      name: "search_course",
      component: search_course,
      // redirect: "/publicClass_lise",
      meta: {
        title: "启德考培在线",
        keyWords: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/search_pubilc",
      name: "search_pubilc",
      component: search_pubilc,
      // redirect: "/publicClass_lise",
      meta: {
        title: "启德考培在线",
        keyWords: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/search_selfStudy",
      name: "search_selfStudy",
      component: search_selfStudy,
      // redirect: "/publicClass_lise",
      meta: {
        title: "启德考培在线",
        keyWords: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/search_TestPaper",
      name: "search_TestPaper",
      component: search_TestPaper,
      // redirect: "/publicClass_lise",
      meta: {
        title: "启德考培在线",
        keyWords: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/search_Section",
      name: "search_Section",
      component: search_Section,
      // redirect: "/publicClass_lise",
      meta: {
        title: "启德考培在线",
        keyWords: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/search_languageTest",
      name: "search_languageTest",
      component: search_languageTest,
      // redirect: "/publicClass_lise",
      meta: {
        title: "启德考培在线",
        keyWords: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/publicClass_list/",
      name: "publicClass_list",
      component: publicClass_list,
      // redirect: "/publicClass_lise",
      meta: {
        title: "热门公开课",
        keyWords: "启德考培公开课,雅思公开课,托福公开课",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/publicClass_details",
      name: "publicClass_details",
      component: publicClass_details,
      meta: {
        title: "启德考培旗下在线课堂_出国考试在线培训_考培网校",
        keyWords:
          "启德考培在线课程,雅思在线课程,托福在线课程,雅思课程,托福课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/publicClass_order",
      name: "publicClass_order",
      component: publicClass_order,
      meta: {
        title: "热播课程订单"
      }
    },
    {
      path: "/publicClass_pay",
      name: "publicClass_pay",
      component: publicClass_pay,
      meta: {
        title: "热播课程订单支付"
      }
    },
    {
      path: "/publicClass_success",
      name: "publicClass_success",
      component: publicClass_success,
      meta: {
        title: "热播课程支付成功"
      }
    },
    {
      path: "/publicClass_failure",
      name: "publicClass_failure",
      component: () => import("../page2/publicClass/publicClass_failure"),
      meta: {
        title: "热播课程支付失败"
      }
    },
    {
      path: "/selfStudy_list/:flag?",
      name: "selfStudy_list",
      props: true,
      component: selfStudy_list,
      meta: {
        title: "自学备考专区-",
        keyWords:
          "自学备考专区,雅思自学备考,雅思备考攻略,托福自学备考,托福备考攻略",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/selfStudy_details",
      name: "selfStudy_details",
      component: selfStudy_details,
      meta: {
        title: "自学备考专区-",
        keyWords:
          "自学备考专区,雅思自学备考,雅思备考攻略,托福自学备考,托福备考攻略",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/languageTest",
      name: "languageTest",
      component: languageTest,
      meta: {
        title: "入学测试-",
        keyWords:
          "启德考培免费测试系统,备考史密斯测试系统,雅思免费测试,托福免费测试",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/course",
      name: "course",
      component: course,
      meta: {
        title: "精品课程",
        keyWords:
          "启德考培在线课程,雅思在线课程,托福在线课程,雅思课程,托福课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/course_list",
      name: "course_list",
      component: course_list,
      meta: {
        title: "精品课程",
        keyWords:
          "启德考培在线课程,雅思在线课程,托福在线课程,雅思课程,托福课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/course_search",
      name: "course_search",
      component: course_search,
      meta: {
        title: "搜索"
      }
    },
    {
      path: "/course_details",
      name: "course_details",
      component: course_details,
      meta: {
        title: "启德考培旗下在线课堂_出国考试在线培训_考培网校",
        keyWords: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/course_auxiliary",
      name: "course_auxiliary",
      component: course_auxiliary,
      meta: {
        title: "启德考培旗下在线课堂_出国考试在线培训_考培网校",
        keyWords: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/course_order",
      name: "course_order",
      component: course_order,
      meta: {
        title: "课程订单"
      }
    },
    {
      path: "/course_pay",
      name: "course_pay",
      component: course_pay,
      meta: {
        title: "课程订单支付"
      }
    },
    {
      path: "/course_success",
      name: "course_success",
      component: course_success,
      meta: {
        title: "课程订单支付成功"
      }
    },
    {
      path: "/course_failure",
      name: "course_failure",
      component: () => import("../page2/courseList/course_failure"),
      meta: {
        title: "课程订单支付失败"
      }
    },
    {
      path: "/teacher_list",
      name: "teacher_list",
      component: teacher_list,
      meta: {
        title: "启德考培教师团队",
        keyWords: "启德考培教师,雅思教师,托福教师,",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
      // children:[

      // ]
    },
    {
      path: "/teacher_details",
      name: "teacher_details",
      component: teacher_details,
      meta: {
        title: "启德考培教师团队",
        keyWords: "启德考培教师,雅思教师,托福教师,",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/shop_list",
      name: "shop_list",
      component: shop_list,
      meta: {
        title: "积分商城-",
        keyWords:
          "启德考培在线积分商城,启德考培在线课程,雅思在线课程,托福在线课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/shop_details",
      name: "shop_details",
      component: shop_details,
      meta: {
        title: "积分商城-",
        keyWords:
          "启德考培在线积分商城,启德考培在线课程,雅思在线课程,托福在线课程",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/shop_order",
      name: "shop_order",
      component: shop_order,
      meta: {
        title: "积分兑换订单确认"
      }
    },
    {
      path: "/agreement1_yhzx",
      name: "agreement1_yhzx",
      component: agreement1_yhzx,
      meta: {
        title: "《启德考培在线用户协议》"
      }
    },
    {
      path: "/agreement1_ysbh",
      name: "agreement1_ysbh",
      component: agreement1_ysbh,
      meta: {
        title: "《启德考培在线隐私保护协议》"
      }
    },
    {
      path: "/downloads",
      name: "downloads",
      component: downloads,
      meta: {
        title: "客户端下载-",
        keyWords: "启德考培在线,启德考培在线下载",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/about",
      component: () => import("../page2/about/about"), //关于我们
      meta: {
        title: "关于我们-",
        keyWords: "启德考培,启德考培雅思,启德考培托福,雅思考试,雅思备考",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/testPrep",
      component: () => import("../page2/testPrep/testPrep"), //备考工具
      meta: {
        title: "免费备考工具-",
        keyWords:
          "免费备考工具,启德考培在线,备考工具,考雅机经,托福机经,雅思能力测评",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/personalCentre/editor",
      name: "editor",
      component: editor,
      meta: {
        title: "客户端下载-",
        keyWords: "启德考培在线,启德考培在线下载",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    {
      path: "/personalCentre",
      component: personalCentre,
      meta: {
        title: "个人中心"
      },
      // redirect: "personalCentre/calendar",
      children: [
        {
          path: "noData",
          component: () => import("../page/noData/noData"), //没有数据时的空页
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "IntegralGain",
          component: () => import("../page/IntegralGain/IntegralGain"), //积分----（获取积分）
          meta: {
            title: "个人中心"
          }
        },
        // {
        //   path: "calendar",
        //   component: () => import("../page/calendar/calendar"), //账户设置----（日历）
        //   meta: {
        //     title: "个人中心"
        //   }
        // },
        {
          path: "xxcalendar",
          component: () => import("../page/xxcalendar/xxcalendar"), //账户设置----（日历）
          meta: {
            title: "个人中心"
          }
        },
        // {
        //   path: "editor",
        //   component: () => import("../page/editor/editor"), //账户设置----（个人信息）
        //   meta: {
        //     title: "个人中心"
        //   }
        // },
        {
          path: "address",
          component: () => import("../page/address/address"), //账户设置----（收获地址）
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "bindings",
          component: () => import("../page/bindings/bindings"), //账户设置----（账号绑定）
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "myCourses",
          component: () => import("../page/myCourses/myCourses"), //我的订单----（积分兑换订单）
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "myCoursesB",
          component: () => import("../page/myCoursesB/myCoursesB"), //我的订单----（积分兑换订单）
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "myCoursesC",
          component: () => import("../page/myCoursesC/myCoursesC"), //我的订单----（积分兑换订单）
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "myMission",
          component: () => import("../page/myMission/myMission"), //学习任务中心----（课程订单）
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "myMission2",
          component: () => import("../page/myMission/myMission2"), //我的公开课
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "myLanguage",
          component: () => import("../page/myLanguage/myLanguage"), //我的语言测试
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "checkDetails",
          component: () => import("../page/myMission/checkDetails"), //查看详情页
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "report",
          component: () => import("../page/myMission/report"), //查看学习报告
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "reportDetails",
          component: () => import("../page/myMission/reportDetails"), //查看学习报告
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "myAttention",
          component: () => import("../page/myAttention/myAttention"), //我的关注
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "collectTopic",
          component: () => import("../page/collectTopic/collectTopic"), //我的关注
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "notice",
          component: () => import("../page/notice/notice"), //我的通知
          meta: {
            title: "个人中心"
          }
        },
        {
          path: "coupon",
          component: () => import("../page/coupon/coupon"), //激活兑换
          meta: {
            title: "个人中心"
          }
        }
      ]
    },
    {
      path: "/practice_system_list",
      name: "practice_system_list",
      component: practice_system_list,
      meta: {
        title: "套题模考",
        keyWords: "启德考培教师,雅思教师,托福教师,",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      },
      beforeEnter:(to,form,next)=>{
        $api.get("https://schoolapi.eiceducation.com.cn/api/UserInfo", "",result=>{
          if(VueCookies.get('token')){
            store.commit('setUserInfo',result.data.results)
          }else{
            store.commit('setUserInfo',{Type:1})
          }
          next()
        } )
      }
      // children:[

      // ]
    },
    {
      path: "/practice_system_list2",
      name: "practice_system_list2",
      component: practice_system_list2,
      meta: {
        title: "单项练习",
        keyWords: "启德考培教师,雅思教师,托福教师,",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      },
      beforeEnter:(to,form,next)=>{
        $api.get("https://schoolapi.eiceducation.com.cn/api/UserInfo", "",result=>{
          if(VueCookies.get('token')){
            store.commit('setUserInfo',result.data.results)
          }else{
            store.commit('setUserInfo',{Type:1})
          }
          next()
        } )
      }
      // children:[

      // ]
    },
    {
      path: "/loading",
      name: "loading",
      component: loadingPage,
      meta: {
        title: "客户端下载-",
        keyWords: "启德考培在线,启德考培在线下载",
        description:
          "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
      }
    },
    // {
    //   path: '/personalCentre/date',
    //   component: () => import("../page/calendar/date"),

    // }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    //如果设置标题，拦截后设置标题
    document.title = to.meta.title;
  }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js